/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GuardarServicioSuscripcionResponse = {
  state: number;
  value: any;
};

export const guardarServicioSuscripcion = async (
  servicios: string[] | undefined
): Promise<any> => {
  try {
    const res = await apiClient.post<GuardarServicioSuscripcionResponse>(
      Endpoints.GuardarServicioSuscripcion,
      { servicios }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
